<script setup lang="ts">
  import { provide } from 'vue'
  import { portCallTypesKey } from '@gat-ship/types/injection-keys'
  import { usePortCallTypesDataSource } from '../../../composables/usePortCallTypesDataSource'

  const props = withDefaults(
    defineProps<{
      /** Fetch the registry once when the provider mounts. */
      fetchOnMount?: boolean
    }>(),
    { fetchOnMount: true }
  )

  const service = usePortCallTypesDataSource()

  if (props.fetchOnMount) {
    void service.fetch()
  }

  provide(portCallTypesKey, service)
  defineExpose(service)
</script>

<template>
  <slot />
</template>
